/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ZutrittskontrolleEventDto } from '../../models/zutrittskontrolle-event-dto';

export interface GetZutrittskontrolleProtokoll$Json$Params {

/**
 * Ereignisse ab diesem Zeitpunkt (inklusive)
 */
  Von?: string;

/**
 * Ereignisse bis zu diesem Zeitpunkt (exklusive)
 */
  Bis?: string;
  Zugelassen?: boolean;

/**
 * "Online" oder "Terminal"
 */
  Quelle?: string;
  Seriennummer?: string;
  ZugangsleserId?: string;

/**
 * Exakte Chipnummer im Systemformat
 */
  ChipNr?: string;

/**
 * Freitextsuche in Vorname, Nachname und Personalnummer
 */
  Person?: string;

/**
 * Nummer der Seite die angezeigt werden soll.
 */
  PageNumber?: number;

/**
 * Anzahl der Einträge pro Seite. Maximal 100
 */
  PageSize?: number;

/**
 * Sortierung der Ergebnisse vor dem Filtern im Format: <br></br>(attribut) [(asc | desc)], ...(attribut) [(asc |
 * desc)],
 */
  OrderBy?: string;
}

export function getZutrittskontrolleProtokoll$Json(http: HttpClient, rootUrl: string, params?: GetZutrittskontrolleProtokoll$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ZutrittskontrolleEventDto>>> {
  const rb = new RequestBuilder(rootUrl, getZutrittskontrolleProtokoll$Json.PATH, 'get');
  if (params) {
    rb.query('Von', params.Von, {});
    rb.query('Bis', params.Bis, {});
    rb.query('Zugelassen', params.Zugelassen, {});
    rb.query('Quelle', params.Quelle, {});
    rb.query('Seriennummer', params.Seriennummer, {});
    rb.query('ZugangsleserId', params.ZugangsleserId, {});
    rb.query('ChipNr', params.ChipNr, {});
    rb.query('Person', params.Person, {});
    rb.query('PageNumber', params.PageNumber, {});
    rb.query('PageSize', params.PageSize, {});
    rb.query('OrderBy', params.OrderBy, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ZutrittskontrolleEventDto>>;
    })
  );
}

getZutrittskontrolleProtokoll$Json.PATH = '/v1/zutrittskontrolle/protokoll';
